import { makeCustomerRecommendationsRepository } from 'modules/customer/infra/repositories';

import { FetchRecommendationsHistoryUseCase } from './implementations/FetchRecommendationsHistoryUseCase';

let instance: FetchRecommendationsHistoryUseCase | null = null;

export default function makeFetchRecommendationsHistoryUseCase() {
  if (!instance) {
    const repository = makeCustomerRecommendationsRepository();

    instance = new FetchRecommendationsHistoryUseCase(repository);
  }

  return instance;
}
